import React from 'react';
import { epices } from '../data/epices';
import ImageLoader from '../components/ImageLoader';
import '../styles/global.css';

const EpicePage = ({ epiceId, onNavigate, melangeId }) => {
  const epice = epices.find(e => e.id === epiceId);
  if (!epice) {
    return (
      <div className="container section text-center">
        <h2>Épice non trouvée</h2>
        <button className="btn btn-primary" onClick={() => onNavigate('home')}>Retour à l'accueil</button>
      </div>
    );
  }

  // Navigation vers autres épices
  const autresEpices = epices.filter(e => e.id !== epiceId);

  return (
    <div className="fade-in">
      <section className="section">
        <div className="container" style={{ maxWidth: 700 }}>
          <button className="btn btn-secondary mb-3" onClick={() => onNavigate(melangeId || 'home')}>← Retour au mélange</button>
          <div className="card" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '2.5rem' }}>
            <div style={{ width: 180, height: 180, borderRadius: 24, overflow: 'hidden', marginBottom: 32, border: '3px solid var(--color-primary)' }}>
              <ImageLoader src={epice.image} alt={epice.nom} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            </div>
            <h1 className="mb-2" style={{ color: 'var(--color-primary)' }}>{epice.nom}</h1>
            <div className="mb-2" style={{ fontWeight: 600, color: 'var(--color-text)' }}><span style={{ color: 'var(--color-melange)' }}>Origine :</span> {epice.origine}</div>
            <div className="mb-2" style={{ color: 'var(--color-text-light)' }}><b>Bienfaits :</b> {epice.bienfaits}</div>
            <div className="mb-3" style={{ fontStyle: 'italic', color: 'var(--color-text)' }}><b>Anecdote :</b> {epice.anecdote}</div>
          </div>
          <div className="mt-4">
            <h3 style={{ color: 'var(--color-primary)', marginBottom: 12 }}>Découvrir d'autres épices</h3>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12 }}>
              {autresEpices.map(e => (
                <button key={e.id} className="btn btn-secondary" onClick={() => onNavigate('epice', e.id, melangeId)}>{e.nom}</button>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default EpicePage; 